export default "__VITE_ASSET__db039145__"